import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { IAppState } from 'store/reducers/rootReducer';
import { faStar } from './constants';
import { GlobalModulesSection } from './styles';

interface Props {
  onHover: (e: React.MouseEvent<HTMLDivElement>, favorites: any) => void;
  onLeave: () => void;
}

export const FavoritesSection: React.FC<Props> = ({ onHover, onLeave }) => {
  const favouritesTabs = useSelector((state: IAppState) => state.favouritesTabs);
  const hasFavorites = Object.keys(favouritesTabs.items).length > 0;

  if (!hasFavorites) {
    return null;
  }

  return (
    <>
      <GlobalModulesSection>
        <FavoritesItem onMouseEnter={(e) => onHover(e, favouritesTabs)} onMouseLeave={onLeave}>
          <FavoritesIcon>
            <FontAwesomeIcon icon={faStar} />
          </FavoritesIcon>
          <FavoritesTitle>Favourites</FavoritesTitle>
          <FavoritesCount>{Object.keys(favouritesTabs.items).length}</FavoritesCount>
        </FavoritesItem>
      </GlobalModulesSection>
      <Divider />
    </>
  );
};

// Styled components specific to favorites
const FavoritesItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 2px 0;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

const FavoritesIcon = styled.div`
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  svg {
    font-size: 15px;
    color: #ffb700;
  }
`;

const FavoritesTitle = styled.span`
  font-size: 15px;
  color: #d4d8e4;
  font-weight: 500;
  letter-spacing: 0.3px;
  flex: 1;
`;

const FavoritesCount = styled.span`
  font-size: 12px;
  color: #ffb700;
  background: rgba(255, 183, 0, 0.2);
  padding: 3px 7px;
  border-radius: 10px;
  margin-left: 8px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 183, 0, 0.2) 20%, rgba(255, 183, 0, 0.2) 80%, transparent);
  margin: 16px 0;
`;
